import { render, staticRenderFns } from "./RbuSectionItemPaginatedList.vue?vue&type=template&id=93d7fdfc"
import script from "./RbuSectionItemPaginatedList.vue?vue&type=script&lang=js"
export * from "./RbuSectionItemPaginatedList.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionItemPaginatedList.vue?vue&type=style&index=0&id=93d7fdfc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports